import mapStateToProps from './map-state-to-props'
import Sidebar from './sidebar'
import SidebarContainer from './container'

export default {
  Sidebar,
  SidebarContainer,
  getSidebarProps: mapStateToProps
}
